import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { ValidateInput } from 'core-components/library/validation'
import { getWidgetMeta } from 'core-components/sitebuilder/helpers/MetaSelector'
import { ISystemWidgetSettings } from 'core-components/sitebuilder/models/flexGrid/ISystemWidgetSettings'
import { IRoute } from 'core-components/sitebuilder/models/IRoute'

import { VisibilitySettings } from './VisibilitySettings'

import commonStyles from './SettingsCommonStyles.module.scss'

interface IAdditionalSettings {
  viewModel: string
  settings: string
  onChange: (newSettings: string) => void
}
export const AdditionalSettings = (props: IAdditionalSettings) => {
  const { urlMapping } = getWidgetMeta(props.viewModel)

  const [settings, setSettings] = useState<ISystemWidgetSettings>(() => {
    try {
      return JSON.parse(props.settings)
    } catch (e) {
      return {}
    }
  })

  const changeSettingsValue = (values: Partial<ISystemWidgetSettings>) => {
    const newSettings = {
      ...settings,
      ...values,
    }
    setSettings(newSettings)
    props.onChange(JSON.stringify(newSettings))
  }

  return (
    <div>
      <VisibilitySettings
        settings={{
          showWhen: settings.showWhen,
          hideWhen: settings.hideWhen,
          showWhenValue: settings.showWhenValue,
          hideWhenValue: settings.hideWhenValue,
        }}
        onChange={changeSettingsValue}
      />
      {settings.routes?.length || urlMapping?.length ? (
        <div className={commonStyles.header}>URL to props mapping:</div>
      ) : null}

      {!urlMapping ? (
        <>
          {settings.routes?.map((el: IRoute, index: number) => (
            <div className={commonStyles.line} key={index}>
              <Input
                classes={{ root: commonStyles.inputWidth }}
                label="URL parameter name"
                value={el.paramName}
                onChange={(value: string) => {
                  if (settings.routes) {
                    settings.routes[index] = {
                      ...settings.routes[index],
                      paramName: value,
                    }

                    changeSettingsValue({
                      routes: [...settings.routes],
                    })
                  }
                }}
              />
              <Input
                classes={{ root: commonStyles.inputWidth }}
                label="Component property name"
                value={el.propName}
                onChange={(value) => {
                  if (settings.routes) {
                    settings.routes[index] = {
                      ...settings.routes[index],
                      propName: value,
                    }

                    changeSettingsValue({
                      routes: [...settings.routes],
                    })
                  }
                }}
              />
              <Button
                variant={'text'}
                iconButton={'kbase kbase-delete'}
                onClick={() => {
                  if (settings.routes) {
                    settings.routes.splice(index, 1)
                    changeSettingsValue({
                      routes: [...settings.routes],
                    })
                  }
                }}
              />
            </div>
          ))}
        </>
      ) : (
        <div className={commonStyles.urlMapping}>
          {urlMapping.map((el, i: number) => {
            const settingsRoutes =
              settings.routes?.find((rout) => rout.propName === el.propName) || ({} as IRoute)
            const index = settings.routes?.findIndex((rout) => rout.propName === el.propName)
            if (index === undefined || index < 0) {
              const routes = settings.routes || []
              routes.push({
                paramName: '',
                propName: el.propName,
                query: false,
              })
              changeSettingsValue({
                routes: [...routes],
              })
            }
            return (
              <div key={i} className={commonStyles.line}>
                <Input
                  classes={{ root: commonStyles.inputWidth }}
                  disabled
                  value={el.propName}
                  label="Component property name"
                />
                <ValidateInput
                  classes={{ validatorClasses: { root: commonStyles.inputWidth } }}
                  checkFn={async () => {
                    return el.isRequired && !settingsRoutes.paramName ? 'Field must be filled' : ''
                  }}
                  label="URL parameter name"
                  value={settingsRoutes.paramName || ''}
                  onChange={(value) => {
                    if (settings.routes) {
                      const oneRoute = settings.routes[index ? index : 0]
                      settings.routes[index ? index : 0] = {
                        ...oneRoute,
                        propName: el.propName,
                        paramName: value,
                      }
                      changeSettingsValue({
                        routes: [...settings.routes],
                      })
                    }
                  }}
                />
                <Tooltip
                  className={'content-invisible'}
                  tipContent={() => <div>{'tips'}</div>}
                  horizontalStartPosition={TPopupHorizontal.Center}
                  horizontalDirection={TPopupHorizontal.Center}
                >
                  <Button variant={'text'} iconButton={'kbase kbase-info'} />
                </Tooltip>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
